import { turboproApiLista } from '@/api/turbopro';
import type {
  AgendamentoApi,
  ListarAgendamentosFiltros,
  ListarAgendamentosResponse,
} from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listarAgendamentosApi(
  filtros: ListarAgendamentosFiltros
): Promise<ListarAgendamentosResponse> {
  // POST com body, não GET com querystring — confirmado no Swagger real.
  const resposta = await turboproApiLista<AgendamentoApi>('Relatorios/ListarAgendamentos', {
    method: 'POST',
    body: {
      Relatorio_id: filtros.relatorioId,
      CNPJ_Contribuinte: filtros.cnpjContribuinte ?? '',
    },
    headers: getRelatoriosHeaders(),
  });
  return resposta.data ?? [];
}
